export const GET_CENTRES = "GET_CENTRES";
export const ADD_CENTRE = "ADD_CENTRE";
export const EDIT_CENTRE = "EDIT_CENTRE";
export const GET_CENTRE = "GET_CENTRE";
export const RESET_CENTRE = "RESET_CENTRE";
export const ERROR_CENTRE = "ERROR_CENTRE";
export const GET_ALL_CENTRES = "GET_ALL_CENTRES";
            